import React, { Component } from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
import SideBar from '../../components/SideBar/SideBar';
import {
  Alert,
  Button,
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  InputGroup,
  Row,
} from 'react-bootstrap';
import {
  ErrorMessage,
  Form,
  Formik,
} from 'formik';
import LoadingButton from '../../components/LoadingButton/LoadingButton';
import * as yup from 'yup';
import cx from 'classnames';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import { canBatch } from '../../stores/batch/can-batch';

class Washout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: '',
      warning: '',
    };

    this.schema = null;
  }

  componentWillMount() {
    this.setSchema();
  }

  initialData() {
    const { materialStore, settingsStore } = this.props;
    const { configuration } = settingsStore;
    const { water } = materialStore;
    const details = water ? materialStore.materialDetails[water.materialDetailId] : null;

    return {
      materialId: water ? water.itemId : null,
      quantity: configuration ? configuration.washoutAmount || '' : '',
      unit: details ? details.itemBatchUnitSymbol : 'unit',
    };
  };

  setSchema() {
    this.schema = yup.object().shape({
      materialId: yup.number().required('Required!'),
      quantity: yup.number().min(1, 'Minimum: 1').required('Required!'),
    });
  }

  onDemoClick = (submitForm) => {
    const { batchStore, diagnoseStore } = this.props;

    if (!batchStore.isDemo && batchStore.running.length) {
      batchStore.showWarning('Can\'t run DEMO while batching!');
      return;
    }

    if (diagnoseStore.isTesting) {
      batchStore.showWarning('Can\'t run DEMO while running Diagnose Auto Test!');
      return;
    }

    batchStore.isDemo = true;
    submitForm();
  };

  onBatchClick = (submitForm) => {
    const { batchStore, diagnoseStore } = this.props;

    if (batchStore.isDemo && batchStore.running.length) {
      batchStore.showWarning('Can not BATCH while running DEMO!');
      return;
    }

    if (diagnoseStore.isTesting) {
      batchStore.showWarning('Can not BATCH while running Diagnose Auto Test!');
      return;
    }

    batchStore.isDemo = false;
    submitForm();
  };

  onResetForm = resetForm => {
    resetForm({
      values: this.initialData(),
    });
    this.resetState();
  };

  resetState = () => {
    this.setState({
      error: '',
      warning: '',
    });
  };

  onSubmit = (values, actions) => {
    const { batchStore, sidebarStore, settingsStore } = this.props;
    const { configuration } = settingsStore;
    const data = batchStore.getInitialMaterialData({
      ...values,
      isWashout: true,
    });

    this.resetState();

    const verification = canBatch(data, settingsStore.rootStore);

    this.setState({
      error: verification.errors.length ? verification.errors.map(v => v.error).join(' ') : '',
      warning: verification.warnings.length ? verification.warnings.join(' ') : '',
    });

    if (!verification.isValid) {
      actions.setSubmitting(false);
      return;
    }

    settingsStore.saveConfiguration({
      ...configuration,
      washoutAmount: values.quantity,
    });

    setTimeout(() => {
      actions.setSubmitting(false);
      batchStore.initData({ ...data, loadStartTime: moment().tz(batchStore.timezone).format() });
      sidebarStore.onToggle(null);
    }, 1000);

  };

  renderRow(values, handleChange, errors, touched, setValues) {
    const { materialStore, t } = this.props;
    const { allWaters } = materialStore;

    return (
      <React.Fragment>
        <Row>
          <Col sm={6}>
            <ControlLabel>{t('Material')}</ControlLabel>
            <FormGroup className={cx({'has-error': errors.materialId && touched.materialId} )}>
              <FormControl
                name="materialId"
                key="materialId"
                componentClass="select"
                value={values.materialId || ''}
                onChange={e => {
                  const materialId = e.target.value;
                  const unit = materialStore.getMaterialUnitSymbol(materialId);
                  this.resetState();
                  setValues({
                    ...values,
                    materialId,
                    unit,
                  });
                }}
                bsSize="sm"
              >
                <option value=""/>
                {allWaters.map(material => (
                  <option key={material.itemId} value={material.itemId}>
                    {materialStore.getMaterialName(material)}
                  </option>
                ))}
              </FormControl>
              <ErrorMessage component="span" name={'materialId'} className="help-block" />
            </FormGroup>
          </Col>
          <Col sm={6}>
            <ControlLabel>{t('Qty')}</ControlLabel>
            <FormGroup className={cx({'has-error': errors.quantity && touched.quantity} )}>
              <InputGroup>
                <FormControl
                  key="quantity"
                  name="quantity"
                  type="number"
                  min="1"
                  max="100000"
                  value={isNaN(values.quantity) ? '' : values.quantity}
                  onChange={handleChange}
                  bsSize="sm"
                />
                <InputGroup.Addon>
                  {values.unit}
                </InputGroup.Addon>
              </InputGroup>
              <ErrorMessage component="span" name={'quantity'} className="help-block" />
            </FormGroup>
          </Col>

        </Row>
      </React.Fragment>
    );
  };

  renderSubmit(values, handleSubmit, submitForm, resetForm, isSubmitting) {
    const { t } = this.props;

    return (
      <React.Fragment>
        <Row>
          <Col sm={12}>
            {!!this.state.error && <Alert bsStyle="danger">{this.state.error}</Alert>}
            {!!this.state.warning && <Alert bsStyle="warning">{this.state.warning}</Alert>}
          </Col>
          <Col sm={12} className="text-right">
            <p>
              <Button onClick={() => this.onResetForm(resetForm)} title={t('Reset')}>{t('Reset')}</Button>
              {' '}
              <Button onClick={() => this.onDemoClick(submitForm)} title={t('Demo')}>{t('Demo')}</Button>
              {' '}
              <LoadingButton
                bsStyle="primary"
                onClick={() => this.onBatchClick(submitForm)}
                label={t('Batch')}
                loadingLabel={t('Loading')}
                isLoading={isSubmitting}
              />
            </p>
          </Col>
        </Row>
      </React.Fragment>
    );
  };

  renderForm() {
    return (
      <Formik
        enableReinitialize
        initialValues={
          this.initialData()
        }
        validateOnChange={true}
        validationSchema={this.schema}
        onSubmit={this.onSubmit}
      >{({ handleSubmit,
          handleChange,
          setValues,
          values,
          errors,
          touched,
          isSubmitting,
          resetForm,
          submitForm,
        }) => (
          <Form className={'batch-material-form'}>
            {this.renderRow(values, handleChange, errors, touched, setValues)}
            {this.renderSubmit(values, handleSubmit, submitForm, resetForm, isSubmitting)}
          </Form>

        )}
      </Formik>
    );
  };

  render() {
    const { materialStore } = this.props;

    return !materialStore.materialDetailsLoaded ? '' : (
      <SideBar type="washout" title={'Washout'} icon={'fa-tint'}>
        {this.renderForm()}
      </SideBar>
    );
  };
}

export default withTranslation()(inject('batchStore', 'sidebarStore', 'materialStore', 'diagnoseStore', 'settingsStore')(observer(Washout)));
